const MockData = [

    {
        "groupName": "linux",
        "isAllOnline": true,
        "numberOfDevices": 1,
        "numberOfDevicesOnline": 1
    },
    {
        "groupName": "ad",
        "isAllOnline": false,
        "numberOfDevices": 2,
        "numberOfDevicesOnline": 1
    },
    {
        "groupName": "firewall",
        "isAllOnline": false,
        "numberOfDevices": 3,
        "numberOfDevicesOnline": 2
    },
    {
        "groupName": "loadbalancer",
        "isAllOnline": true,
        "numberOfDevices": 1,
        "numberOfDevicesOnline": 1
    },
    {
        "groupName": "windows",
        "isAllOnline": true,
        "numberOfDevices": 3,
        "numberOfDevicesOnline": 3
    },
    {
        "groupName": "switch",
        "isAllOnline": true,
        "numberOfDevices": 12,
        "numberOfDevicesOnline": 12
    }
];


export default MockData



// WEBPACK FOOTER //
// ./src/dashboard/widgets/deviceGroupsMockData.js